export default __webpack_public_path__ + "static/media/652.8c7c628e.png";